import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { Reports } from '../reports.model';
import { ReportsService } from '../reports.service';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Globle } from 'src/assets/globle';

@Component({
  selector: 'app-ordersdirectcharged',
  templateUrl: './ordersdirectcharged.component.html',
  styleUrls: ['./ordersdirectcharged.component.css']
})
export class OrdersdirectchargedComponent implements OnInit {

  reports: Reports[] = [];
  displayedColumns: string[] = ['userName', 'category', 'subCategory', 'product', "quantity",
    'costPrice', 'total', "date", "phoneInfo"];
  dataSource!: MatTableDataSource<Reports>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;
  spinnerOverlay = false
  lang = 'en';
  reportObj: Reports = {} as Reports
  pageSize = 100;
  constructor(private service: ReportsService,
    private translate: TranslateService,
    private globle: Globle) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
  }

  get() {
    this.spinnerOverlay = true;
    this.service.getAllDirectCharged(this.fromDate.nativeElement.value, this.toDate.nativeElement.value).subscribe(data => {

      this.reports = data;

      this.dataSource = new MatTableDataSource(this.reports);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
        this.reports = [];
        this.dataSource = new MatTableDataSource(this.reports);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      })
  }

  onApply() {
    this.get();
  }

  Print() {

    const doc = new jsPDF({ filters: ["ASCIIHexEncode"] });

    doc.addFileToVFS("../../assets/Amiri/Amiri-Regular.ttf", this.globle.AmiriRegular);
    doc.addFont("../../assets/Amiri/Amiri-Regular.ttf", "Amiri", "normal");

    doc.setFont("Amiri");

    doc.setFontSize(18);
    doc.setTextColor(40);
    //doc.setFont("",'normal');

    doc.text("كشف شحن مباشر ", 90, 10);
    doc.text("_________________________________", 50, 12);


    if (this.fromDate.nativeElement.value != null && this.fromDate.nativeElement.value != ""
      && this.toDate.nativeElement.value != null && this.toDate.nativeElement.value != "") {
      doc.text(" من تاريخ : " + this.fromDate.nativeElement.value, 100, 20, {
        isOutputRtl: true
      });
      doc.text(" الى تاريخ : " + this.toDate.nativeElement.value, 50, 20, {
        isOutputRtl: true
      });
    }

    //autoTable({ html: '#orderProductTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    autoTable(doc, { html: '#dirChargedTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    //doc.save("test.pdf");
    doc.output('dataurlnewwindow');
  }

  getTotal() {
    var total = 0;
    for (var i = 0; i < this.reports.length; i++) {
      if (this.reports[i].status != 2) {
        total += this.reports[i].total
      }
    }
    return total.toFixed(3);
    // return this.reports.map(t => t.total).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  getTotalCostPrice() {
    var total = 0;
    for (var i = 0; i < this.reports.length; i++) {
      if (this.reports[i].status != 2) {
        total += this.reports[i].costPrice
      }
    }
    return total.toFixed(3);
  }


}
